{
  "name": "bsky.app",
  "version": "1.137.0",
  "private": true,
  "packageManager": "pnpm@11.28.5",
  "sideEffects": [
    "*.css",
    "./src/logger/sentry/setup/*",
    "./src/platform/polyfills*",
    "./src/platform/markBundleStartTime.ts",
    "./index.ts",
    "./index.web.ts"
  ],
  "engines": {
    "node": ">=24.22.1"
  },
  "devEngines": {
    "packageManager": {
      "name": "pnpm",
      "version": "11.28.5",
      "onFail": "warn"
    },
    "runtime": {
      "name": "node",
      "version": "^24.22.1",
      "onFail": "download"
    }
  },
  "expo": {
    "autolinking": {
      "android": {
        "buildFromSource": [
          "expo-notifications",
          "expo-media-library"
        ]
      }
    },
    "install": {
      "exclude": [
        "react-native-reanimated",
        "@sentry/react-native",
        "react-native-pager-view",
        "react-native-view-shot",
        "react-native-webview",
        "react-native-worklets",
        "typescript"
      ]
    }
  },
  "scripts": {
    "prepare": "is-ci || husky",
    "postinstall": "pnpm lexicons:generate && pnpm intl:compile-if-needed",
    "prebuild": "EXPO_NO_GIT_STATUS=1 expo prebuild --clean",
    "patch:react-native": "rm -rf node_modules/.patch-react-native && pnpm patch react-native@0.88.0 --ignore-existing --edit-dir node_modules/.patch-react-native && git apply --directory=node_modules/.patch-react-native patches/react-native/*.patch && pnpm patch-commit node_modules/.patch-react-native && pnpm update react-native --depth 0",
    "android": "expo run:android --variant debugOptimized",
    "android:prod": "pnpm intl:build && expo run:android --variant release",
    "android:profile": "pnpm intl:build && BSKY_PROFILE=1 expo run:android --variant release",
    "ios": "bash scripts/runIos.sh",
    "ios:prepare-testflight": "bash scripts/prepareIosTestflight.sh",
    "web": "expo start --web",
    "use-build-number": "./scripts/useBuildNumberEnv.sh",
    "use-build-number-with-bump": "./scripts/useBuildNumberEnvWithBump.sh",
    "build-web": "EXPO_UNSTABLE_METRO_OPTIMIZE_GRAPH=1 EXPO_UNSTABLE_TREE_SHAKING=1 expo export --platform web --source-maps && node ./scripts/post-web-build.js && node ./scripts/gen-oauth-metadata.js && node ./scripts/gen-newsroom-hosts.js",
    "deploy:cloudflare": "bash scripts/deploy-cloudflare.sh",
    "check-web-browser-support": "es-check checkBrowser 'dist/_expo/static/js/web/**/*.js' --module --checkFeatures --browserslistEnv=production --ignore=Uint8ArrayFromBase64,Uint8ArrayToBase64 --noColor",
    "build-all": "pnpm intl:build && pnpm use-build-number-with-bump eas build --platform all",
    "build-ios": "pnpm intl:build && pnpm use-build-number-with-bump eas build -p ios",
    "build-android": "pnpm intl:build && pnpm use-build-number-with-bump eas build -p android",
    "build": "pnpm intl:build && pnpm use-build-number-with-bump eas build",
    "build-embed": "cd bskyembed && pnpm build && pnpm build-snippet && cd .. && node ./scripts/post-embed-build.js",
    "start": "expo start --dev-client",
    "start:prod": "expo start --dev-client --no-dev --minify",
    "test": "NODE_ENV=test jest --forceExit --testTimeout=20000 --bail",
    "test-watch": "NODE_ENV=test jest --watchAll",
    "test-ci": "NODE_ENV=test jest --ci --forceExit --reporters=default --reporters=jest-junit",
    "test-coverage": "NODE_ENV=test jest --coverage",
    "lint": "oxlint --quiet src modules && node scripts/check-sentry-browser-version.mjs",
    "lint:fix": "oxlint --fix --prune-suppressions src modules",
    "lint-native": "swiftlint ./modules && ktlint ./modules",
    "lint-native:fix": "swiftlint --fix ./modules && ktlint --format ./modules",
    "lexicons:generate": "lex build --clear --index-file --import-ext ''",
    "lexicons:install": "lex install",
    "lexicons:update": "lex install --update",
    "lexicons:verify": "lex install --ci",
    "typecheck": "pnpm run typecheck:ios && pnpm run typecheck:android && pnpm run typecheck:web",
    "typecheck:ios": "tsc --project ./tsconfig.check.ios.json",
    "typecheck:android": "tsc --project ./tsconfig.check.android.json",
    "typecheck:web": "tsc --project ./tsconfig.check.web.json",
    "brand:gen-logo": "node scripts/gen-logo.mjs",
    "brand:check-logo": "node scripts/gen-logo.mjs --check",
    "brand:sync-web": "node scripts/sync-brand-web.mjs",
    "brand:check-web": "node scripts/sync-brand-web.mjs --check",
    "brand:gen-assets": "node scripts/gen-brand-assets.mjs",
    "brand:check-assets": "node scripts/gen-brand-assets.mjs --check",
    "brand:gen-favicons": "node scripts/gen-brand-favicons.mjs",
    "brand:check-favicons": "node scripts/gen-brand-favicons.mjs --check",
    "brand:gen-raster": "node scripts/gen-raster.mjs",
    "brand": "node scripts/gen-logo.mjs && node scripts/sync-brand-web.mjs && node scripts/gen-brand-assets.mjs && node scripts/gen-brand-favicons.mjs",
    "brand:check": "node scripts/gen-logo.mjs --check && node scripts/sync-brand-web.mjs --check && node scripts/gen-brand-assets.mjs --check && node scripts/gen-brand-favicons.mjs --check",
    "e2e:mock-server": "cd dev-env && pnpm start",
    "e2e:build": "EXPO_PUBLIC_ENV=e2e NODE_ENV=development RN_SRC_EXT=e2e.ts,e2e.tsx expo run:ios",
    "e2e:build-android": "EXPO_PUBLIC_ENV=e2e NODE_ENV=development RN_SRC_EXT=e2e.ts,e2e.tsx expo run:android",
    "e2e:start": "EXPO_PUBLIC_ENV=e2e NODE_ENV=development RN_SRC_EXT=e2e.ts,e2e.tsx expo start -c",
    "e2e:run": "maestro test",
    "perf:test": "NODE_ENV=test maestro test",
    "perf:test:run": "NODE_ENV=test maestro test __e2e__/perf-test.yml",
    "perf:test:measure": "NODE_ENV=test flashlight test --bundleId xyz.blueskyweb.app --testCommand \"pnpm perf:test\" --duration 150000 --resultsFilePath .perf/results.json",
    "perf:test:results": "NODE_ENV=test flashlight report .perf/results.json",
    "perf:measure": "NODE_ENV=test flashlight measure",
    "intl:build": "pnpm intl:extract:all && pnpm intl:compile && pnpm intl:check",
    "intl:check": "NODE_ENV=production node scripts/check-release-i18n.cjs",
    "intl:extract": "lingui extract --clean --locale en",
    "intl:extract:all": "lingui extract --clean",
    "intl:compile": "lingui compile",
    "intl:lint": "eloqnt lint",
    "intl:compile-if-needed": "is-ci || [ -f src/locale/locales/en/messages.ts ] || pnpm intl:compile",
    "intl:pull": "crowdin download translations --verbose -b main",
    "intl:push-sources": "crowdin push sources --verbose -b main",
    "intl:dangerously-push-translations": "crowdin push translations --verbose -b main",
    "intl:release": "pnpm intl:pull && pnpm intl:extract:all",
    "intl:resync": "bash scripts/intl-resync.sh",
    "nuke": "rm -rf ./node_modules && rm -rf ./ios && rm -rf ./android",
    "update-extensions": "bash scripts/updateExtensions.sh",
    "export": "expo export --platform ios --platform android --dump-sourcemap && pnpm upload-native-sourcemaps",
    "upload-native-sourcemaps": "pnpm exec sentry-expo-upload-sourcemaps dist",
    "generate-web-stats": "EXPO_ATLAS=1 pnpm build-web",
    "open-analyzer": "npx expo-atlas .expo/atlas.jsonl",
    "icons:generate": "node ./scripts/icons/generate.mts",
    "icons:check": "node scripts/gen-phosphor-icons.mjs --check && node ./scripts/icons/generate.mts --check",
    "icons:test": "node --test ./scripts/icons/lib.test.mts",
    "icons:import-phosphor": "node scripts/gen-phosphor-icons.mjs",
    "prettier": "prettier --check .",
    "prettier:fix": "prettier --write"
  },
  "dependencies": {
    "@atproto/common-web": "0.5.10",
    "@atproto/jwk": "0.6.0",
    "@atproto/jwk-jose": "0.1.11",
    "@atproto/jwk-webcrypto": "0.2.0",
    "@atproto/lex": "0.3.8",
    "@atproto/lex-password-session": "0.2.2",
    "@atproto/oauth-client": "0.5.14",
    "@atproto/oauth-client-browser": "0.3.40",
    "@atproto/syntax": "0.7.5",
    "@bitdrift/react-native": "^0.6.8",
    "@braintree/sanitize-url": "^6.0.2",
    "@bsky.app/alf": "^0.1.15",
    "@bsky.app/bottom-sheet": "link:./modules/bottom-sheet",
    "@bsky.app/expo-background-notification-handler": "link:./modules/expo-background-notification-handler",
    "@bsky.app/expo-bluesky-gif-view": "link:./modules/expo-bluesky-gif-view",
    "@bsky.app/expo-bluesky-swiss-army": "link:./modules/expo-bluesky-swiss-army",
    "@bsky.app/expo-dynamic-app-icon": "^1.8.5",
    "@bsky.app/expo-emoji-picker": "link:./modules/expo-emoji-picker",
    "@bsky.app/expo-guess-language": "^0.2.8",
    "@bsky.app/expo-image-crop-tool": "^0.5.1",
    "@bsky.app/expo-scroll-edge-effect": "^0.1.10",
    "@bsky.app/expo-translate-text": "^0.2.9",
    "@bsky.app/peek-menu": "^0.3.2",
    "@bsky.app/react-native-scroll-forwarder": "link:./modules/react-native-scroll-forwarder",
    "@bsky.app/react-native-uitextview": "^2.7.1",
    "@bsky.app/sift": "^0.3.9",
    "@bsky.app/tapper": "^0.6.1",
    "@bsky.app/video": "0.4.2",
    "@bsky.app/video-compressor": "0.2.0",
    "@bsky/sdk": "1.2.0",
    "@emoji-mart/data": "^1.2.1",
    "@emoji-mart/react": "^1.1.1",
    "@expo/html-elements": "^0.12.5",
    "@expo/metro-runtime": "~58.0.14",
    "@expo/ui": "58.0.20",
    "@floating-ui/dom": "^1.6.3",
    "@floating-ui/react-dom": "^2.0.8",
    "@formatjs/intl-displaynames": "^7.3.9",
    "@formatjs/intl-locale": "^5.3.8",
    "@formatjs/intl-numberformat": "^9.3.10",
    "@formatjs/intl-pluralrules": "^6.3.9",
    "@growthbook/growthbook": "^1.6.5",
    "@growthbook/growthbook-react": "^1.6.5",
    "@ipld/dag-cbor": "^9.2.7",
    "@lingui/core": "^5.9.2",
    "@lingui/react": "^5.9.2",
    "@plausible-analytics/tracker": "0.4.5",
    "@react-native-async-storage/async-storage": "2.2.0",
    "@react-navigation/bottom-tabs": "^7.15.5",
    "@react-navigation/native": "^7.1.33",
    "@react-navigation/native-stack": "^7.14.4",
    "@sentry/browser": "10.74.0",
    "@sentry/react-native": "~8.26.0",
    "@tanstack/query-async-storage-persister": "^5.96.2",
    "@tanstack/react-query": "^5.96.2",
    "@tanstack/react-query-persist-client": "^5.96.2",
    "@tiptap/core": "^2.9.1",
    "@tiptap/extension-document": "^2.9.1",
    "@tiptap/extension-hard-break": "^2.9.1",
    "@tiptap/extension-history": "^2.9.1",
    "@tiptap/extension-mention": "^2.9.1",
    "@tiptap/extension-paragraph": "^2.9.1",
    "@tiptap/extension-placeholder": "^2.9.1",
    "@tiptap/extension-text": "^2.9.1",
    "@tiptap/pm": "^2.9.1",
    "@tiptap/react": "^2.9.1",
    "@tiptap/suggestion": "^2.9.1",
    "@types/invariant": "^2.2.37",
    "@types/lodash.throttle": "^4.1.9",
    "@types/node": "^24.12.2",
    "array.prototype.findlast": "^1.2.3",
    "array.prototype.findlastindex": "^1.2.6",
    "babel-plugin-transform-remove-console": "^6.9.4",
    "bcp-47": "^2.1.0",
    "bcp-47-match": "^2.0.3",
    "bidi-js": "^1.0.3",
    "date-fns": "^4.4.0",
    "email-validator": "^2.0.4",
    "emoji-mart": "^5.6.0",
    "emoji-regex": "^10.4.0",
    "eventemitter3": "^5.0.1",
    "expo": "58.0.14",
    "expo-age-range": "58.0.2",
    "expo-application": "~58.1.2",
    "expo-asset": "~58.0.16",
    "expo-atlas": "^0.4.3",
    "expo-blur": "~58.0.4",
    "expo-build-properties": "~58.0.11",
    "expo-camera": "~58.0.10",
    "expo-clipboard": "~58.0.3",
    "expo-contacts": "^58.0.7",
    "expo-dev-client": "~58.0.14",
    "expo-device": "~58.0.5",
    "expo-file-system": "~58.0.9",
    "expo-font": "~58.0.8",
    "expo-glass-effect": "58.0.4",
    "expo-haptics": "~58.0.7",
    "expo-image": "58.0.15",
    "expo-image-manipulator": "~58.0.14",
    "expo-image-picker": "~58.0.10",
    "expo-intent-launcher": "~58.0.3",
    "expo-keep-awake": "~58.0.3",
    "expo-linear-gradient": "~58.0.3",
    "expo-linking": "~58.0.13",
    "expo-localization": "~58.0.4",
    "expo-location": "~58.0.17",
    "expo-media-library": "58.0.10",
    "expo-modules-core": "58.0.22",
    "expo-notifications": "58.1.5",
    "expo-paste-input": "^0.2.1",
    "expo-privacy-sensitive": "^0.2.0",
    "expo-screen-orientation": "~58.0.3",
    "expo-sharing": "~58.0.19",
    "expo-sms": "^58.0.2",
    "expo-splash-screen": "~58.0.10",
    "expo-system-ui": "~58.0.6",
    "expo-updates": "58.0.17",
    "expo-video": "~58.0.11",
    "expo-video-thumbnails": "^58.0.2",
    "expo-web-browser": "~58.0.6",
    "fast-deep-equal": "^3.1.3",
    "fast-text-encoding": "^1.0.6",
    "fuse.js": "^7.1.0",
    "hls.js": "^1.6.2",
    "idb-keyval": "^6.2.2",
    "js-sha256": "^0.9.0",
    "jwt-decode": "^4.0.0",
    "lande": "^1.0.10",
    "libphonenumber-js": "^1.12.31",
    "lodash.chunk": "^4.2.0",
    "lodash.debounce": "^4.0.8",
    "lodash.shuffle": "^4.2.0",
    "lodash.throttle": "^4.1.1",
    "lowlight": "^3.3.0",
    "mediabunny": "^1.25.3",
    "multiformats": "^13.4.2",
    "nanoid": "^5.0.5",
    "normalize-url": "^8.0.0",
    "psl": "1.9.0",
    "radix-ui": "^1.4.3",
    "react": "19.3.0",
    "react-compiler-runtime": "1.0.0",
    "react-dom": "19.3.0",
    "react-hotkeys-hook": "5.2.4",
    "react-image-crop": "^11.0.7",
    "react-is": "19",
    "react-keyed-flatten-children": "^5.0.0",
    "react-native": "0.88.0",
    "react-native-device-attest": "^0.1.6",
    "react-native-drawer-layout": "5.0.0-alpha.19",
    "react-native-edge-to-edge": "^1.8.1",
    "react-native-gesture-handler": "~3.3.0",
    "react-native-keyboard-controller": "1.22.7",
    "react-native-mmkv": "^3.3.3",
    "react-native-nano-icons": "1.0.1",
    "react-native-pager-view": "9.0.9",
    "react-native-progress": "^5.0.1",
    "react-native-qrcode-styled": "^0.3.3",
    "react-native-reanimated": "4.7.1",
    "react-native-safe-area-context": "~5.10.1",
    "react-native-screens": "4.30.0",
    "react-native-svg": "15.16.0",
    "react-native-uuid": "^2.0.3",
    "react-native-view-shot": "^5.1.0",
    "react-native-web": "^0.21.4",
    "react-native-web-webview": "^1.0.2",
    "react-native-webview": "^13.16.1",
    "react-native-worklets": "0.13.0",
    "react-remove-scroll-bar": "^2.3.8",
    "react-responsive": "^10.0.1",
    "react-textarea-autosize": "^8.5.3",
    "setimmediate": "^1.0.5",
    "slugify": "^1.6.9",
    "sonner": "^2.0.7",
    "sonner-native": "0.26.4",
    "tippy.js": "^6.3.7",
    "tlds": "^1.234.0",
    "tldts": "^6.1.46",
    "unicode-segmenter": "0.14.5",
    "upng-js": "^2.1.0",
    "zod": "^3.25.76"
  },
  "devDependencies": {
    "@babel/core": "^7.29.7",
    "@babel/preset-env": "^7.26.0",
    "@babel/runtime": "^7.26.0",
    "@crowdin/cli": "^4.14.1",
    "@eloqnt/cli": "0.6.26",
    "@lingui/babel-plugin-lingui-macro": "^5.9.2",
    "@lingui/cli": "^5.9.2",
    "@phosphor-icons/core": "2.1.1",
    "@react-native/babel-preset": "0.88.0",
    "@react-native/jest-preset": "0.88.0",
    "@react-native/typescript-config": "0.88.0",
    "@resvg/resvg-js": "^2.6.2",
    "@testing-library/react-native": "^13.2.0",
    "@types/jest": "30.0.0",
    "@types/jsdom": "^21.1.7",
    "@types/lodash.chunk": "^4.2.7",
    "@types/lodash.debounce": "^4.0.7",
    "@types/lodash.shuffle": "^4.2.7",
    "@types/psl": "1.1.1",
    "@types/react": "^19.3.0",
    "@types/react-dom": "^19.2.3",
    "@types/upng-js": "^2.1.5",
    "@typescript/native": "npm:typescript@^7.0.2",
    "babel-jest": "^30.5.2",
    "babel-plugin-module-resolver": "^5.0.2",
    "babel-plugin-react-compiler": "1.0.0",
    "babel-preset-expo": "~58.0.17",
    "eas-build-cache-provider": "24.8.0",
    "es-check": "9.8.1",
    "eslint-plugin-bsky-internal": "link:lint-rules",
    "eslint-plugin-react-native-a11y": "^3.5.1",
    "eslint-plugin-simple-import-sort": "^13.0.0",
    "globals": "^17.0.0",
    "husky": "^9.1.7",
    "is-ci": "^3.0.1",
    "jest": "^30.5.2",
    "jest-expo": "~58.0.11",
    "jest-junit": "^16.0.0",
    "jsdom": "^26.1.0",
    "lint-staged": "^17.0.8",
    "oxlint": "^1.73.0",
    "oxlint-tsgolint": "^7.0.2001",
    "prettier": "3.9.6",
    "react-test-renderer": "19.3.0",
    "sharp": "^0.35.4",
    "svgo": "^4.0.2",
    "ts-plugin-sort-import-suggestions": "^1.0.4",
    "typescript": "npm:@typescript/typescript6@^6.0.2"
  },
  "jest": {
    "preset": "jest-expo/ios",
    "setupFilesAfterEnv": [
      "./jest/jestSetup.js"
    ],
    "moduleFileExtensions": [
      "ts",
      "tsx",
      "js",
      "jsx",
      "json",
      "node"
    ],
    "transform": {
      "\\.[jt]sx?$": "babel-jest"
    },
    "moduleNameMapper": {
      "^multiformats$": "<rootDir>/node_modules/multiformats/dist/src/index.js",
      "^multiformats/cid$": "<rootDir>/node_modules/multiformats/dist/src/cid.js",
      "^multiformats/bases/base32$": "<rootDir>/node_modules/multiformats/dist/src/bases/base32.js",
      "^multiformats/hashes/digest$": "<rootDir>/node_modules/multiformats/dist/src/hashes/digest.js",
      "^multiformats/hashes/hasher$": "<rootDir>/node_modules/multiformats/dist/src/hashes/hasher.js",
      "^multiformats/hashes/sha2$": "<rootDir>/node_modules/multiformats/dist/src/hashes/sha2.js",
      "^uint8arrays/from-string$": "<rootDir>/node_modules/uint8arrays/dist/src/from-string.js",
      "^uint8arrays/to-string$": "<rootDir>/node_modules/uint8arrays/dist/src/to-string.js",
      "^unicode-segmenter/grapheme$": "<rootDir>/node_modules/unicode-segmenter/grapheme.cjs",
      "^await-lock$": "<rootDir>/node_modules/await-lock/build/AwaitLock.js",
      "^@ipld/dag-cbor$": "<rootDir>/node_modules/@ipld/dag-cbor/src/index.js",
      "^cborg$": "<rootDir>/node_modules/cborg/cborg.js"
    },
    "transformIgnorePatterns": [
      "node_modules/(?!((jest-)?react-native|@react-native(-community)?)|expo(nent)?|@expo(nent)?/.*|@expo-google-fonts/.*|react-navigation|nanoid|@react-navigation/.*|@unimodules/.*|unimodules|sentry-expo|native-base|normalize-url|react-native-svg|@sentry/.*|sentry-expo|bcp-47-match|@atproto/.*|@bsky/sdk|tlds|multiformats|uint8arrays|@ipld/.*|cborg|await-lock|lowlight|devlop)"
    ],
    "modulePathIgnorePatterns": [
      "__tests__/.*/__mocks__",
      "__e2e__/.*",
      "bskylink/.*",
      "<rootDir>/services/"
    ],
    "coveragePathIgnorePatterns": [
      "<rootDir>/node_modules/",
      "<rootDir>/src/platform",
      "<rootDir>/src/third-party",
      "<rootDir>/src/view/com/util",
      "<rootDir>/src/state/lib",
      "<rootDir>/__tests__/test-utils.js"
    ],
    "reporters": [
      "default",
      "jest-junit"
    ]
  },
  "browserslist": {
    "production": [
      "chrome >= 97",
      "and_chr >= 97",
      "edge >= 97",
      "firefox >= 104",
      "and_ff >= 104",
      "safari >= 15.4",
      "ios_saf >= 15.4",
      "samsung >= 18"
    ],
    "development": [
      "last 1 chrome version",
      "last 1 firefox version",
      "last 1 safari version"
    ]
  },
  "lint-staged": {
    "{src,modules}/**/*.{js,jsx,ts,tsx}": [
      "oxlint --fix --no-error-on-unmatched-pattern"
    ],
    "*{.js,.jsx,.ts,.tsx,.css}": [
      "prettier --cache --write --ignore-unknown"
    ],
    "assets/icons/{ui,brands,community,custom}/*.svg": [
      "svgo"
    ]
  }
}
